    /* =========================================================
       VON STRIGA TATTOO — HOMEPAGE JS
       Phase 1: client-side only (no backend yet)
       ========================================================= */

    // -------------------- HAMBURGER / SIDE MENU --------------------
    (function () {
      const ham = document.getElementById('hamburger');
      const menu = document.getElementById('menu');
      const scrim = document.getElementById('menuScrim');
      const menuClose = document.getElementById('menuClose');

      function openMenu() {
        ham.classList.add('active');
        menu.classList.add('open');
        scrim.classList.add('open');
        menuClose.classList.add('menu-open');
        document.body.classList.add('menu-is-open');
        ham.setAttribute('aria-expanded', 'true');
        menu.setAttribute('aria-hidden', 'false');
        scrim.setAttribute('aria-hidden', 'false');
      }
      function closeMenu() {
        ham.classList.remove('active');
        menu.classList.remove('open');
        scrim.classList.remove('open');
        menuClose.classList.remove('menu-open');
        document.body.classList.remove('menu-is-open');
        ham.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
        scrim.setAttribute('aria-hidden', 'true');
      }
      function toggleMenu() {
        if (menu.classList.contains('open')) closeMenu(); else openMenu();
      }
      ham.addEventListener('click', toggleMenu);
      menuClose.addEventListener('click', toggleMenu);
      scrim.addEventListener('click', closeMenu);
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && menu.classList.contains('open')) closeMenu();
      });
    })();

    // -------------------- VOTED BEST LINE FIT GUARD --------------------
    // Safety net: if the VOTED BEST text ever gets clipped (e.g. on a 320px
    // iPhone SE in portrait), shrink the font until it fits on one line.
    (function () {
      const el = document.querySelector('.voted-best');
      if (!el) return;
      const MIN_PX = 6;

      function fit() {
        // Reset to natural CSS-clamped size
        el.style.fontSize = '';
        // If overflowing, step down 0.5px at a time until it fits.
        let safety = 30;
        while (el.scrollWidth > el.clientWidth && safety-- > 0) {
          const cs = getComputedStyle(el);
          const cur = parseFloat(cs.fontSize);
          const next = Math.max(MIN_PX, cur - 0.5);
          if (next === cur) break;
          el.style.fontSize = next + 'px';
        }
      }
      fit();
      window.addEventListener('resize', fit);
      // Re-run after web fonts load (Cheddar Gothic from Typekit) — fixes a
      // first-paint case where fallback font width != real font width.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(fit);
      } else {
        window.addEventListener('load', fit);
      }
    })();

    // -------------------- ARTIST CAROUSEL --------------------
    // Fetches real artists from /api/public/artists (only non-hidden, ordered
    // by display_order set in the dashboard). Falls back to placeholder data
    // if the API is unreachable. Each card shows a specialties banner across
    // the middle of the photo. Cards link to artist-page.html?slug=...
    // (production also supports clean /artists/<slug> URLs via _redirects).
    // Carousel scrolls infinitely — auto-drift, slows on hover/touch, momentum
    // swipe, click arrows on desktop.
    (function () {
      const API_BASE = 'https://vonstriga-api.vonstrigack.workers.dev';
      const R2_BASE = 'https://pub-586df1996ad24b05bdde57caa46de5a6.r2.dev';

      // Fallback so the carousel never appears empty even if the API is down.
      const PLACEHOLDER_ARTISTS = [
        { display_name: 'Artist 01', slug: 'artist-01', profile_photo_key: null, specialties: '' },
        { display_name: 'Artist 02', slug: 'artist-02', profile_photo_key: null, specialties: '' },
        { display_name: 'Artist 03', slug: 'artist-03', profile_photo_key: null, specialties: '' },
        { display_name: 'Artist 04', slug: 'artist-04', profile_photo_key: null, specialties: '' },
        { display_name: 'Artist 05', slug: 'artist-05', profile_photo_key: null, specialties: '' }
      ];

      const carousel = document.getElementById('artistCarousel');
      const track = document.getElementById('artistTrack');
      const prevBtn = document.getElementById('artistNavPrev');
      const nextBtn = document.getElementById('artistNavNext');
      if (!carousel || !track) return;

      function escapeHtml(s) {
        return String(s || '')
          .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      }
      function renderSpecialties(spec) {
        const parts = (spec || '').split(',').map(s => s.trim()).filter(Boolean);
        return parts.length ? parts.join(' · ') : '';
      }

      function buildCard(artist) {
        const a = document.createElement('a');
        a.className = 'artist-card';
        const targetUrl = `/pages/artist?${encodeURIComponent(artist.slug || '')}`;
        a.href = targetUrl;
        a.setAttribute('aria-label', `View ${artist.display_name}'s portfolio`);
        // Click handler: only block the navigation if we just finished a real
        // drag. Otherwise let the browser navigate via the href naturally.
        // (Click events fire on the actual click target regardless of
        // setPointerCapture, unlike pointerup events.)
        a.addEventListener('click', (e) => {
          if (justDragged) {
            e.preventDefault();
            e.stopPropagation();
          }
          // else — let the default <a href> navigation happen
        });
        const photoUrl = artist.profile_photo_key
          ? `${R2_BASE}/${artist.profile_photo_key}` : null;
        const photoMarkup = photoUrl
          ? `<img src="${escapeHtml(photoUrl)}" alt="${escapeHtml(artist.display_name)}" draggable="false">`
          : `<div class="artist-card-placeholder"></div>`;
        const specialties = renderSpecialties(artist.specialties);
        const banner = specialties
          ? `<div class="artist-card-specialties"><span class="artist-card-specialties-label">Specialties</span><span class="artist-card-specialties-list">${escapeHtml(specialties)}</span></div>`
          : '';
        a.innerHTML = `
          <div class="artist-card-photo-wrap">
            ${photoMarkup}
            ${banner}
          </div>
          <div class="artist-card-name">${escapeHtml(artist.display_name)}</div>`;
        return a;
      }

      // Duplicate the artist list multiple times so there's always content
      // to scroll into. 8 copies is overkill but bulletproof.
      let COPIES = 8;
      function buildTrack(artists) {
        track.innerHTML = '';
        // If we only have a few real artists, copy them more times so the
        // visible track stays full. If we have many, fewer copies.
        COPIES = artists.length >= 5 ? 4 : 8;
        const frag = document.createDocumentFragment();
        for (let i = 0; i < COPIES; i++) {
          artists.forEach(a => frag.appendChild(buildCard(a)));
        }
        track.appendChild(frag);
        // Re-measure after rebuild so the scroll engine knows new track size
        setTimeout(measure, 50);
      }

      // ---- Scroll engine ----
      // Auto-scroll never fully stops. When the user hovers/interacts, it
      // SLOWS to a gentle drift; when idle, it returns to normal speed.
      const SPEED_NORMAL_PX_PER_SEC = 28;
      const SPEED_HOVER_PX_PER_SEC = 8;   // gentle drift on hover/interaction
      const RESUME_AFTER_MS = 3000;
      let position = 0;
      let oneSetWidth = 0;
      let lastTimestamp = null;
      let slowMode = false; // true = drift slowly, false = full speed
      let resumeTimer = null;

      // ---- Drag / swipe state ----
      let isDragging = false;
      let dragStartX = 0;
      let dragStartPosition = 0;
      let lastDragX = 0;
      let lastDragTime = 0;
      let dragVelocity = 0; // px per ms
      let momentumActive = false;
      let momentumVelocity = 0;
      let justDragged = false; // suppress click immediately after drag

      // Swipe responsiveness — multiplier on the user's drag distance so
      // a small swipe carries the carousel further. Tuned for fast feel.
      const SWIPE_MULTIPLIER = 1.5;
      // Momentum decay per frame (1 = no friction, 0 = stop instantly)
      const MOMENTUM_FRICTION = 0.96;
      // Below this absolute velocity (px/ms), momentum stops
      const MOMENTUM_STOP_THRESHOLD = 0.015;

      function measure() {
        oneSetWidth = track.scrollWidth / COPIES;
      }

      function wrapPosition() {
        // Always keep position within [0, oneSetWidth) so the loop is truly
        // infinite — impossible to ever scroll past an "end".
        if (oneSetWidth > 0) {
          position = ((position % oneSetWidth) + oneSetWidth) % oneSetWidth;
        }
      }

      function applyTransform() {
        wrapPosition();
        track.style.transform = `translateX(${-position}px)`;
      }

      function tick(timestamp) {
        if (lastTimestamp === null) lastTimestamp = timestamp;
        const deltaMs = timestamp - lastTimestamp;
        const delta = deltaMs / 1000;
        lastTimestamp = timestamp;

        if (oneSetWidth > 0) {
          if (isDragging) {
            // While dragging, position is set directly by pointer handlers
          } else if (momentumActive) {
            // Apply momentum, decaying over time. Uncapped velocity so
            // fast flicks carry far before friction brings them to rest.
            position += momentumVelocity * deltaMs;
            momentumVelocity *= MOMENTUM_FRICTION;
            if (Math.abs(momentumVelocity) < MOMENTUM_STOP_THRESHOLD) {
              momentumActive = false;
            }
            applyTransform();
          } else {
            // Auto-drift always — slow on hover/interaction, full speed when idle.
            const speed = slowMode ? SPEED_HOVER_PX_PER_SEC : SPEED_NORMAL_PX_PER_SEC;
            position += speed * delta;
            applyTransform();
          }
        }
        requestAnimationFrame(tick);
      }

      function startCarousel() {
        measure();
        requestAnimationFrame(tick);
      }
      if (document.readyState === 'complete') {
        startCarousel();
      } else {
        window.addEventListener('load', startCarousel);
      }
      let resizeTimer = null;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(measure, 150);
      });

      function slowDown() {
        slowMode = true;
        clearTimeout(resumeTimer);
      }
      function scheduleResume() {
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(() => { slowMode = false; }, RESUME_AFTER_MS);
      }

      // ---- Hover slow-down (desktop) ----
      carousel.addEventListener('mouseenter', () => { if (!isDragging) slowDown(); });
      carousel.addEventListener('mouseleave', () => { if (!isDragging) scheduleResume(); });

      // ---- Pointer drag (works for mouse and touch via pointer events) ----
      // IMPORTANT: setPointerCapture is intentionally NOT called on pointerdown.
      // If we capture on every pointerdown — including simple clicks with no
      // motion — the browser redirects all subsequent pointer events to the
      // carousel and the click event won't dispatch correctly to the card.
      // Result: right-click "Open in new tab" works (bypasses click handler),
      // but left-click doesn't navigate. We solve this by only capturing
      // AFTER actual drag motion is detected (>5px) in pointermove.
      let captureRequested = false;
      function onPointerDown(e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (oneSetWidth === 0) measure();
        isDragging = true;
        momentumActive = false;
        slowDown();
        dragStartX = e.clientX;
        dragStartPosition = position;
        lastDragX = e.clientX;
        lastDragTime = performance.now();
        dragVelocity = 0;
        captureRequested = false;
      }
      function onPointerMove(e) {
        if (!isDragging) return;
        // First time we cross the drag threshold, request pointer capture
        // so we keep getting events even if the cursor leaves the carousel.
        // Don't capture on pure clicks (no movement) so click dispatches normally.
        if (!captureRequested && Math.abs(e.clientX - dragStartX) > 5) {
          captureRequested = true;
          carousel.classList.add('dragging');
          try { carousel.setPointerCapture(e.pointerId); } catch (err) {}
        }
        const now = performance.now();
        const dx = e.clientX - lastDragX;
        const dt = now - lastDragTime;
        if (dt > 0) {
          const instant = (dx * SWIPE_MULTIPLIER) / dt;
          dragVelocity = dragVelocity * 0.55 + instant * 0.45;
        }
        lastDragX = e.clientX;
        lastDragTime = now;
        const totalDx = (e.clientX - dragStartX) * SWIPE_MULTIPLIER;
        position = dragStartPosition - totalDx;
        applyTransform();
      }
      function onPointerUp(e) {
        if (!isDragging) return;
        isDragging = false;
        carousel.classList.remove('dragging');
        if (captureRequested) {
          try { carousel.releasePointerCapture(e.pointerId); } catch (err) {}
        }
        const totalDx = Math.abs(e.clientX - dragStartX);
        if (totalDx > 20) {
          justDragged = true;
          setTimeout(() => { justDragged = false; }, 50);
          momentumVelocity = -dragVelocity;
          momentumActive = Math.abs(momentumVelocity) > MOMENTUM_STOP_THRESHOLD;
        }
        scheduleResume();
      }
      carousel.addEventListener('pointerdown', onPointerDown);
      carousel.addEventListener('pointermove', onPointerMove);
      carousel.addEventListener('pointerup', onPointerUp);
      carousel.addEventListener('pointercancel', onPointerUp);

      // Prevent native image dragging from interfering
      carousel.addEventListener('dragstart', (e) => e.preventDefault());

      // ---- Arrow nav (desktop) ----
      function nudge(direction) {
        const cards = track.querySelectorAll('.artist-card');
        if (!cards.length) return;
        const cardRect = cards[0].getBoundingClientRect();
        const trackStyles = getComputedStyle(track);
        const gap = parseFloat(trackStyles.gap || trackStyles.columnGap || '0') || 0;
        const cardStep = cardRect.width + gap;
        // Inject momentum equivalent to a quick swipe of one card width
        momentumActive = true;
        momentumVelocity = direction * (cardStep / 280); // smooth glide
        slowDown();
        scheduleResume();
      }
      if (prevBtn) prevBtn.addEventListener('click', () => nudge(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => nudge(1));

      // Initial render — placeholder so the carousel never appears empty.
      buildTrack(PLACEHOLDER_ARTISTS);
      // Then fetch real artists. If we get any back, swap them in.
      fetch(`${API_BASE}/api/public/artists`)
        .then(r => r.ok ? r.json() : null)
        .then(data => {
          if (Array.isArray(data) && data.length > 0) {
            buildTrack(data);
            console.log('[carousel] loaded', data.length, 'artists from API');
          } else {
            console.log('[carousel] API returned no artists, using placeholders');
          }
        })
        .catch((err) => {
          console.warn('[carousel] API fetch failed:', err);
        });

      // SAFETY NET: a delegated click handler on the carousel itself.
      // Even if pointer capture or some other issue prevents the card's own
      // click handler from firing, this catches the click bubbling up.
      carousel.addEventListener('click', (e) => {
        const card = e.target.closest('.artist-card');
        if (!card) return;
        if (justDragged) {
          console.log('[carousel] click blocked — justDragged is true');
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        const href = card.getAttribute('href');
        console.log('[carousel] card clicked, navigating to:', href, 'justDragged:', justDragged);
        if (href && !e.defaultPrevented) {
          // Force navigation in case the native <a> click is being blocked
          // by anything upstream.
          e.preventDefault();
          window.location.href = href;
        }
      });
    })();

    // -------------------- SHOP PHOTO GALLERY --------------------
    // Fetches real shop photos from /api/public/shop-gallery. Falls back to
    // placeholder slides if the fetch fails or returns nothing.
    (function () {
      const API_BASE_GAL = 'https://vonstriga-api.vonstrigack.workers.dev';

      const PLACEHOLDER_SLIDES = [
        { src: null, alt: 'Shop photo 1' },
        { src: null, alt: 'Shop photo 2' },
        { src: null, alt: 'Shop photo 3' },
        { src: null, alt: 'Shop photo 4' },
        { src: null, alt: 'Shop photo 5' }
      ];

      const track = document.getElementById('galleryTrack');
      const dotsWrap = document.getElementById('galleryDots');
      const lightbox = document.getElementById('lightbox');
      const lightboxImg = document.getElementById('lightboxImg');
      const lightboxClose = document.getElementById('lightboxClose');
      const lightboxPrev = document.getElementById('lightboxPrev');
      const lightboxNext = document.getElementById('lightboxNext');
      const galleryPrevBtn = document.getElementById('shopGalleryPrev');
      const galleryNextBtn = document.getElementById('shopGalleryNext');
      if (!track || !dotsWrap) return;

      let slides = PLACEHOLDER_SLIDES.slice();
      let current = 0;
      let timer = null;
      let touchStartX = 0;
      let touchDeltaX = 0;
      let lightboxIdx = 0;     // current photo shown in lightbox
      let lbTouchStartX = 0;
      let lbTouchDeltaX = 0;

      function render() {
        track.innerHTML = '';
        dotsWrap.innerHTML = '';
        // Slides
        const sFrag = document.createDocumentFragment();
        slides.forEach((s, i) => {
          const slide = document.createElement('div');
          slide.className = 'shop-gallery-slide';
          slide.dataset.idx = i;
          if (s.src) {
            slide.innerHTML = `<img src="${s.src}" alt="${s.alt || ''}">`;
          } else {
            slide.innerHTML = `<div class="shop-gallery-placeholder">Shop Photo ${i + 1}</div>`;
          }
          slide.addEventListener('click', () => openLightbox(i));
          sFrag.appendChild(slide);
        });
        track.appendChild(sFrag);

        // Dots
        const dFrag = document.createDocumentFragment();
        slides.forEach((_, i) => {
          const d = document.createElement('button');
          d.className = 'shop-gallery-dot' + (i === 0 ? ' active' : '');
          d.setAttribute('aria-label', `Go to slide ${i + 1}`);
          d.addEventListener('click', (e) => {
            e.stopPropagation();
            goTo(i);
            restartTimer();
          });
          dFrag.appendChild(d);
        });
        dotsWrap.appendChild(dFrag);

        // Reset position to first slide when re-rendering
        current = 0;
        track.style.transform = `translateX(0)`;
      }

      function goTo(i) {
        current = (i + slides.length) % slides.length;
        track.style.transform = `translateX(-${current * 100}%)`;
        document.querySelectorAll('.shop-gallery-dot').forEach((d, idx) => {
          d.classList.toggle('active', idx === current);
        });
      }
      function next() { goTo(current + 1); }
      function prev() { goTo(current - 1); }

      function startTimer() {
        clearInterval(timer);
        timer = setInterval(next, 3000);
      }
      function restartTimer() {
        clearInterval(timer);
        startTimer();
      }

      // Swipe support
      track.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
        touchDeltaX = 0;
        clearInterval(timer);
      }, { passive: true });
      track.addEventListener('touchmove', (e) => {
        touchDeltaX = e.touches[0].clientX - touchStartX;
      }, { passive: true });
      track.addEventListener('touchend', () => {
        if (Math.abs(touchDeltaX) > 50) {
          if (touchDeltaX < 0) next(); else prev();
        }
        restartTimer();
      });

      // Inline gallery arrow buttons (desktop)
      if (galleryPrevBtn) {
        galleryPrevBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          prev();
          restartTimer();
        });
      }
      if (galleryNextBtn) {
        galleryNextBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          next();
          restartTimer();
        });
      }

      // Lightbox
      function showLightboxAt(i) {
        // Skip empty placeholder slides
        const realIndices = slides.map((s, idx) => s.src ? idx : -1).filter(idx => idx !== -1);
        if (realIndices.length === 0) return;
        // Snap to nearest real photo (in case dataset just has placeholders)
        if (!slides[i] || !slides[i].src) {
          i = realIndices[0];
        }
        lightboxIdx = i;
        lightboxImg.src = slides[i].src;
        lightboxImg.alt = slides[i].alt || '';
      }
      function openLightbox(i) {
        const slide = slides[i];
        if (!slide || !slide.src) return; // skip empty placeholder slides
        showLightboxAt(i);
        lightbox.classList.add('open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        clearInterval(timer);
      }
      function closeLightbox() {
        lightbox.classList.remove('open');
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        startTimer();
      }
      function lightboxNextPhoto() {
        // Step forward, skipping over placeholder slides without src
        for (let step = 1; step <= slides.length; step++) {
          const idx = (lightboxIdx + step) % slides.length;
          if (slides[idx] && slides[idx].src) { showLightboxAt(idx); return; }
        }
      }
      function lightboxPrevPhoto() {
        for (let step = 1; step <= slides.length; step++) {
          const idx = (lightboxIdx - step + slides.length) % slides.length;
          if (slides[idx] && slides[idx].src) { showLightboxAt(idx); return; }
        }
      }
      if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
      if (lightboxPrev) {
        lightboxPrev.addEventListener('click', (e) => { e.stopPropagation(); lightboxPrevPhoto(); });
      }
      if (lightboxNext) {
        lightboxNext.addEventListener('click', (e) => { e.stopPropagation(); lightboxNextPhoto(); });
      }
      if (lightbox) lightbox.addEventListener('click', (e) => {
        // Click on the dim backdrop closes; clicks on image/arrows handled above
        if (e.target === lightbox) closeLightbox();
      });
      // Arrow keys + Esc
      document.addEventListener('keydown', (e) => {
        if (!lightbox || !lightbox.classList.contains('open')) return;
        if (e.key === 'Escape') { closeLightbox(); return; }
        if (e.key === 'ArrowRight') { lightboxNextPhoto(); return; }
        if (e.key === 'ArrowLeft') { lightboxPrevPhoto(); return; }
      });
      // Swipe on the lightbox image
      if (lightboxImg) {
        lightboxImg.addEventListener('touchstart', (e) => {
          lbTouchStartX = e.touches[0].clientX;
          lbTouchDeltaX = 0;
        }, { passive: true });
        lightboxImg.addEventListener('touchmove', (e) => {
          lbTouchDeltaX = e.touches[0].clientX - lbTouchStartX;
        }, { passive: true });
        lightboxImg.addEventListener('touchend', () => {
          if (Math.abs(lbTouchDeltaX) > 50) {
            if (lbTouchDeltaX < 0) lightboxNextPhoto();
            else lightboxPrevPhoto();
          }
        });
      }

      // Initial render with placeholder, then fetch real photos
      render();
      startTimer();

      fetch(`${API_BASE_GAL}/api/public/shop-gallery`)
        .then(r => r.ok ? r.json() : null)
        .then(data => {
          const photos = data && Array.isArray(data.photos) ? data.photos : [];
          if (photos.length > 0) {
            slides = photos.map(p => ({ src: p.url, alt: p.caption || '' }));
            render();
            restartTimer();
          }
        })
        .catch(() => { /* keep placeholders if API fails */ });
    })();

    // -------------------- REVIEWS --------------------
    // 5 real 5-star reviews. On every page load, 3 are randomly chosen
    // and shown. Each card is a clickable link to the shop's Google
    // reviews page. No auto-rotation — selection is fixed for the
    // duration of the visit.
    (function () {
      const REVIEWS = [
        { stars: 5, text: 'The nicest cleanest studio I have ever visited. The staff is extremely personable and friendly. The attention to detail and meticulous organization of the studio was soothing in its own way. Going to be traveling back across the country just to come here again.' },
        { stars: 5, text: '3 tattoos at this shop and it is so freaking cool... If you love the 80s you have to go check this spot out! Hands down the best spot!' },
        { stars: 5, text: 'We had 3 people walk in for tattoos! Great service & great tattoos!!' },
        { stars: 5, text: 'Excellent work!' },
        { stars: 5, text: 'I had a wonderful experience, I came with my best friend and it was my first tattoo ever! We felt very comfortable and welcome.' }
      ];

      // Google reviews page for Von Striga (lrd= deep-link goes straight
      // to the reviews panel for the business listing).
      const GOOGLE_REVIEWS_URL = 'https://www.google.com/search?q=vonstriga+galveston#lrd=0x863f9db36d207135:0x17f3910125fc211b,1';

      const VISIBLE_DESKTOP = 3;
      const VISIBLE_MOBILE = 2;
      const row = document.getElementById('reviewsRow');
      if (!row) return;

      function getVisibleCount() {
        return window.innerWidth >= 768 ? VISIBLE_DESKTOP : VISIBLE_MOBILE;
      }

      function pickReviews(n) {
        // Pick n random reviews without repeats
        const pool = [...REVIEWS];
        const out = [];
        for (let i = 0; i < n && pool.length > 0; i++) {
          const idx = Math.floor(Math.random() * pool.length);
          out.push(pool.splice(idx, 1)[0]);
        }
        return out;
      }

      function renderReviews() {
        const reviews = pickReviews(getVisibleCount());
        row.innerHTML = '';
        reviews.forEach(r => {
          const card = document.createElement('a');
          card.className = 'review-card';
          card.href = GOOGLE_REVIEWS_URL;
          card.target = '_blank';
          card.rel = 'noopener';
          card.setAttribute('aria-label', 'Read more reviews on Google');
          card.innerHTML = `
            <div class="review-stars" aria-label="${r.stars} stars">${'★'.repeat(r.stars)}</div>
            <p class="review-text">${r.text}</p>
            <p class="review-source">— Google Review</p>
          `;
          row.appendChild(card);
        });
      }

      renderReviews();

      // Re-render on resize crossing the desktop/mobile breakpoint
      let lastVisible = getVisibleCount();
      window.addEventListener('resize', () => {
        const v = getVisibleCount();
        if (v !== lastVisible) {
          lastVisible = v;
          renderReviews();
        }
      });
    })();

    // -------------------- SHOP SETTINGS (address + phone pills) --------------------
    // Pulls the shop's address and phone from /api/public/shop-settings.
    // Pills always visible — JS just REPLACES the placeholder text + href
    // when real values are available. If the API is unreachable or no value
    // is set, the placeholder stays.
    //
    // On Apple devices (iPhone, iPad, Mac), the address pill opens Apple Maps.
    // Everywhere else it opens Google Maps.
    (function () {
      const API_BASE_SS = 'https://vonstriga-api.vonstrigack.workers.dev';
      const addressLink = document.getElementById('addressPill');
      const addressText = document.getElementById('addressPillText');
      const phoneLink = document.getElementById('phonePill');
      const phoneText = document.getElementById('phonePillText');
      const followIg = document.getElementById('followIg');
      const followFb = document.getElementById('followFb');

      // Detect Apple devices (iPhone/iPad/iPod/Mac) so we can route to Apple
      // Maps. iPadOS 13+ reports as Mac in userAgent, but has touch — we
      // check both UA and a touch-capable Mac to catch iPads.
      function isAppleDevice() {
        const ua = navigator.userAgent || '';
        if (/iPhone|iPad|iPod/.test(ua)) return true;
        // iPadOS 13+ desktop mode — reports as Mac but has touch
        if (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) return true;
        // Regular Macs (Apple Maps works in Safari on macOS)
        if (/Mac OS X/.test(ua)) return true;
        return false;
      }

      function buildMapsUrl(address) {
        const q = encodeURIComponent(address);
        if (isAppleDevice()) {
          // Apple Maps URL — works on iOS, iPadOS, and macOS
          return `https://maps.apple.com/?q=${q}`;
        }
        return `https://www.google.com/maps/search/?api=1&query=${q}`;
      }

      // Convert a stored value (handle like "vonstriga" or full URL) into
      // a full URL for the platform.
      function toIgUrl(val) {
        if (!val) return null;
        const s = String(val).trim();
        if (!s) return null;
        if (/^https?:\/\//i.test(s)) return s;
        const handle = s.replace(/^@/, '').trim();
        return handle ? `https://instagram.com/${handle}` : null;
      }
      function toFbUrl(val) {
        if (!val) return null;
        const s = String(val).trim();
        if (!s) return null;
        if (/^https?:\/\//i.test(s)) return s;
        const handle = s.replace(/^@/, '').trim();
        return handle ? `https://facebook.com/${handle}` : null;
      }

      fetch(`${API_BASE_SS}/api/public/shop-settings`)
        .then(r => r.ok ? r.json() : null)
        .then(data => {
          const s = (data && data.settings) ? data.settings : {};
          if (s.address) {
            addressText.textContent = s.address;
            addressLink.href = buildMapsUrl(s.address);
          }
          if (s.phone) {
            phoneText.textContent = s.phone;
            const cleaned = String(s.phone).replace(/[^\d+]/g, '');
            phoneLink.href = `tel:${cleaned}`;
          }
          // Follow Us — pull instagram + facebook from shop settings.
          // Falls back to the default href on the icon if not set.
          if (followIg) {
            const igUrl = toIgUrl(s.instagram_url);
            if (igUrl) followIg.href = igUrl;
          }
          if (followFb) {
            const fbUrl = toFbUrl(s.facebook_url);
            if (fbUrl) followFb.href = fbUrl;
          }
        })
        .catch(() => { /* keep placeholders if API fails */ });
    })();


    // -------------------- ARTIST GRID --------------------
    // Fetches real artists from /api/public/artists. Renders a 2-column grid
    // of square cards. Each card has the artist name on top, profile photo
    // in the middle, specialties on the bottom (70% black banner). Whole
    // card links to the artist's individual page.
    (function () {
      const API_BASE_GRID = 'https://vonstriga-api.vonstrigack.workers.dev';
      const R2_BASE_GRID = 'https://pub-586df1996ad24b05bdde57caa46de5a6.r2.dev';
      const grid = document.getElementById('artistGrid');
      if (!grid) return;

      function escapeHtml(s) {
        return String(s || '')
          .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      }

      function renderSpecialties(spec) {
        const parts = (spec || '').split(',').map(s => s.trim()).filter(Boolean);
        return parts.length ? parts.join(' · ') : '';
      }

      function buildCard(artist) {
        const a = document.createElement('a');
        a.className = 'artist-grid-card';
        a.href = `/pages/artist?${encodeURIComponent(artist.slug || '')}`;
        a.setAttribute('aria-label', `View ${artist.display_name}'s portfolio`);
        const photoUrl = artist.profile_photo_key
          ? `${R2_BASE_GRID}/${artist.profile_photo_key}` : null;
        const photoMarkup = photoUrl
          ? `<img src="${escapeHtml(photoUrl)}" alt="${escapeHtml(artist.display_name)}">`
          : `<div class="placeholder"></div>`;
        const specialties = renderSpecialties(artist.specialties);
        const specialtiesMarkup = specialties
          ? `<div class="artist-grid-specialties">${escapeHtml(specialties)}</div>`
          : '';
        a.innerHTML = `
          <div class="artist-grid-photo-wrap">${photoMarkup}</div>
          <div class="artist-grid-name">${escapeHtml(artist.display_name)}</div>
          ${specialtiesMarkup}
        `;
        return a;
      }

      function render(artists) {
        grid.innerHTML = '';
        const frag = document.createDocumentFragment();
        artists.forEach(a => frag.appendChild(buildCard(a)));
        grid.appendChild(frag);
      }

      fetch(`${API_BASE_GRID}/api/public/artists`)
        .then(r => r.ok ? r.json() : null)
        .then(data => {
          if (Array.isArray(data) && data.length > 0) {
            render(data);
            console.log('[artists] rendered', data.length, 'cards');
          } else {
            console.log('[artists] API returned no artists');
          }
        })
        .catch((err) => {
          console.warn('[artists] fetch failed:', err);
        });
    })();


    // -------------------- WIDGET HEIGHT AUTO-RESIZE --------------------
    // Listens for postMessage from the booking widget for height updates.
    // Accepts every known iframe-resize protocol shape. The container
    // (.widget-body) and the iframe both grow together so the widget never
    // scrolls internally.
    (function () {
      const body = document.getElementById('widgetBody');
      if (!body) return;

      function applyHeight(h) {
        if (typeof h !== 'number' || !isFinite(h) || h < 100) return;
        const iframe = body.querySelector('iframe');
        if (iframe) {
          iframe.style.height = h + 'px';
          iframe.setAttribute('height', h);
        }
        body.style.height = h + 'px';
      }

      function extractHeight(data) {
        if (data == null) return null;
        if (typeof data === 'number' && data >= 100) return data;
        if (typeof data === 'string') {
          const ifs = data.match(/^\[iFrameSizer\][^:]*:\d+:(\d+(?:\.\d+)?)/);
          if (ifs) return parseFloat(ifs[1]);
          try {
            const parsed = JSON.parse(data);
            return extractHeight(parsed);
          } catch (e) {}
          return null;
        }
        if (typeof data !== 'object') return null;
        if (Array.isArray(data)) {
          for (const v of data) {
            if (typeof v === 'number' && v >= 100) return v;
          }
          return null;
        }
        if (typeof data.height === 'number' && data.height >= 100) return data.height;
        if (typeof data.value === 'number' && data.value >= 100) return data.value;
        if (data.payload && typeof data.payload.height === 'number') return data.payload.height;
        if (data.data && typeof data.data.height === 'number') return data.data.height;
        if (data.detail && typeof data.detail.height === 'number') return data.detail.height;
        return null;
      }

      window.addEventListener('message', (e) => {
        let originHost = '';
        try { originHost = new URL(e.origin || '').hostname || ''; } catch (err) {}
        if (!/flash-booking\.com$/i.test(originHost)) return;
        const h = extractHeight(e.data);
        if (h !== null) applyHeight(h);
      });
    })();








    /* =========================================================
       BUY BUTTONS — split pill: Add to Cart (left, green) +
       Quick Buy (right, orange). Both use the variant ID stored
       on the clicked button.
       - Add to Cart: silently adds, briefly shows "Added ✓",
         updates the topbar cart badge, lets user keep shopping.
       - Quick Buy: adds + redirects straight to /checkout.
       ========================================================= */
    (function () {
      function refreshCartBadge() {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) {
            if (!cart) return;
            var count = cart.item_count || 0;
            var btn = document.querySelector('.cart-btn');
            if (!btn) return;
            var badge = btn.querySelector('.cart-badge');
            if (count > 0) {
              if (!badge) {
                badge = document.createElement('span');
                badge.className = 'cart-badge';
                btn.appendChild(badge);
              }
              badge.textContent = count;
            } else if (badge) {
              badge.remove();
            }
          })
          .catch(function (err) { console.warn('[cart] badge refresh failed', err); });
      }

      function addToCart(variantId) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        }).then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed: ' + res.status);
          return res.json();
        });
      }

      function handleAddToCart(btn) {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        var originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';

        addToCart(variantId)
          .then(function () {
            btn.textContent = 'Added ✓';
            refreshCartBadge();
            setTimeout(function () {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 1500);
          })
          .catch(function (err) {
            console.error('[add-to-cart]', err);
            btn.disabled = false;
            btn.textContent = originalText;
            alert('Sorry, we could not add this item to your cart. Please try again.');
          });
      }

      function handleQuickBuy(btn) {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        var originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';

        addToCart(variantId)
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (err) {
            console.error('[quick-buy]', err);
            btn.disabled = false;
            btn.textContent = originalText;
            alert('Sorry, we could not add this item to your cart. Please try again.');
          });
      }

      document.addEventListener('click', function (e) {
        var addBtn = e.target.closest && e.target.closest('.vs-btn-addcart');
        if (addBtn && !addBtn.disabled) {
          e.preventDefault();
          handleAddToCart(addBtn);
          return;
        }
        var quickBtn = e.target.closest && e.target.closest('.vs-btn-quickbuy');
        if (quickBtn && !quickBtn.disabled) {
          e.preventDefault();
          handleQuickBuy(quickBtn);
          return;
        }
      });
    })();
